import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { DigitalIDSchoolRequest } from "./DigitalIDSchoolRequest";

@Injectable()
export class DataService_DigitalID_Settings {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DigitalIDSchoolPBISSelectList() {
		var postResult$ = new Subject();
		var url = "DigitalID/DigitalIDSchoolPBISSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolPBISEnable(parms: DigitalIDSchoolRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/SchoolPBISEnable";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolPBISDisable(parms: DigitalIDSchoolRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/SchoolPBISDisable";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
